import { CiFacebook } from "react-icons/ci";
import { FaXTwitter } from "react-icons/fa6";
import { IoLogoLinkedin } from "react-icons/io5";
import { FaWhatsapp } from "react-icons/fa";
import {  
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton,

} from "react-share";

export const SocialShare = ({isTextSHow=true}:{isTextSHow?:boolean}) => {   
    const url = typeof window!== 'undefined'? window.location.href : '';

    return (
        <div className="flex space-x-2 bg-white mt-3 pb-4 rounded-lg flex-wrap justify-start items-center">
            {isTextSHow ? <h3 className="font-bold">Share:</h3> : null}
            <TwitterShareButton url={url}>
                <button className="flex items-center rounded-md px-2 py-2 bg-black text-white hover:opacity-80 focus:outline-none"
                    type="button"
                >
                    <FaXTwitter size={23} />
                </button>
            </TwitterShareButton>
            <FacebookShareButton url={url}>
                <button className="flex items-center rounded-md px-2 py-2 bg-[#3b5998] text-white hover:opacity-80 focus:outline-none"
                    type="button"
                >
                    <CiFacebook size={24} />    
                </button>
            </FacebookShareButton>
            <LinkedinShareButton url={url}>
                <button className="flex items-center rounded-md px-2 py-2 bg-[#007bb6] text-white hover:opacity-80 focus:outline-none"
                    type="button"
                >
                    <IoLogoLinkedin size={24} />    
                </button>
            </LinkedinShareButton>
            <WhatsappShareButton url={url}>
                <button className="flex items-center rounded-md px-2 py-2 bg-[#27B53B] text-white hover:opacity-80 focus:outline-none"
                    type="button"
                >
                    <FaWhatsapp  size={24} />    
                </button>
            </WhatsappShareButton>
        </div>
    )
}
